import * as environment from '../../../config/environment';

import { BaseAPI } from "../../BaseAPI";

class StajBursBasvuruAPI extends BaseAPI {
  

  constructor () {
    const baseUrl = environment.API_URL + "StajBursBasvuruListe";
    super(baseUrl);
  }


  getStajBursBasvuruListe(tcKimlikNo: string,basvuruTuruId?: number,basvuruNo?: number){
    var request= new StajBursBasvuruListeRequest( tcKimlikNo,basvuruTuruId,basvuruNo);
    
    return this.post("",request, false);
  }

}

export default new StajBursBasvuruAPI();
class StajBursBasvuruListeRequest {
  public  basvuruTuruId?: number;
  public  tcKimlikNo: string;
  public  basvuruNo?: number;

 
  constructor(tcKimlikNo: string, basvuruTuruId?: number ,basvuruNo?: number) {
   
      this.basvuruTuruId = basvuruTuruId;
      this.tcKimlikNo=tcKimlikNo;
      this.basvuruNo=basvuruNo;
  }
}
export { StajBursBasvuruListeRequest };